import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import Work from './work/work';
import Home from './home/home.js';

class Routes extends React.Component {
  render() {
    return (
      <BrowserRouter>
        <div>
          <Switch>
            <Route path="/" component={ Home } exact />
            <Route path="/work" component={ Work } />
            <Route path="**">
              <Redirect to="/" />
            </Route>
          </Switch>
        </div>
      </BrowserRouter>
    )
  }
}

export default Routes;